module.exports = __webpack_public_path__ + "img/move.fe1ffbf7.png";